import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionDifferentThisTimePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionDifferentThisTime.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionDifferentThisTime.button1'),
          value: 'ready_to_stick',
        },
        {
          text: t('pages.onboarding.questionDifferentThisTime.button2'),
          value: 'want_to_understand',
        },
        {
          text: t('pages.onboarding.questionDifferentThisTime.button3'),
          value: 'want_simple',
        },
        {
          text: t('pages.onboarding.questionDifferentThisTime.button4'),
          value: 'doing_for_me',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
